import React from 'react';
import { Box, Typography } from '@mui/material';
import {
  Savings,
  EmojiObjects,
  EnergySavingsLeaf,
  TrendingUp,
} from '@mui/icons-material';
import styles from './WhySolar.module.css';

const benefits = [
  {
    title: 'Cost Savings',
    description: 'Lower your electricity expenses substantially with a smart, sustainable energy solution.',
    icon: <Savings color="primary" fontSize="large" />,
  },
  {
    title: 'Government Subsidies',
    description: 'Avail incentives and tax credits on solar adoption, with benefits up to ₹78,000.',
    icon: <EmojiObjects color="warning" fontSize="large" />,
  },
  {
    title: 'Clean Energy Source',
    description: 'Contribute to reducing carbon emissions by embracing a clean and renewable power source.',
    icon: <EnergySavingsLeaf color="success" fontSize="large" />,
  },
  {
    title: 'Long-term ROI',
    description: 'Enhance your property’s value with an energy solution that pays dividends for years to come.',
    icon: <TrendingUp color="secondary" fontSize="large" />,
  },
];

const WhySolar = () => {
  return (
    <div className={styles.whySolarSection}>
      <Typography variant="h4" align="center" className={styles.whySolarHeading}>
        Why Choose Solar Energy?
      </Typography>

      <div className={styles.benefitsWrapper}>
        {benefits.map((benefit, index) => (
          <div key={index} className={styles.whysolarbenefitCard}>
            <div className={styles.iconWrapper}>{benefit.icon}</div>
            <Typography variant="h6" className={styles.cardTitle}>
              {benefit.title}
            </Typography>
            <Typography variant="body2" className={styles.cardDesc}>
              {benefit.description}
            </Typography>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WhySolar;
